import { SIGNING_FLOW_STEPS } from '../constants';
/** Returns the signing-flow steps that apply, dropping the down payment step when none is required. */
function getSigningFlowSteps(downPaymentRequired) {
    return SIGNING_FLOW_STEPS.filter((step) => !step.requiresDownPayment || !!downPaymentRequired);
}
export default getSigningFlowSteps;
